import { mutatorAction } from 'satcheljs';
import type { MoveCopyDialogScenario } from '../utils/checkIfCrossAccountAndShowConfirmationDialogIfNeeded';
import { getStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export const setMoveCopyAttachCrossAccountDialogStateMutator: (
    isOpen: boolean,
    title: string,
    message: string,
    isCrossAccountNotAllowed: boolean,
    type: MoveCopyDialogScenario,
    sourceMailboxInfo: MailboxInfo,
    destinationMailboxInfo: MailboxInfo,
    globalSettingsMailboxInfo: MailboxInfo,
    onDialogResponse: (response: boolean) => void,
    projectionTabId: string | undefined
) => void = mutatorAction(
    'setMoveCopyAttachCrossAccountDialogStateMutator',
    (
        isOpen: boolean,
        title: string,
        message: string,
        isCrossAccountNotAllowed: boolean,
        type: MoveCopyDialogScenario,
        sourceMailboxInfo: MailboxInfo,
        destinationMailboxInfo: MailboxInfo,
        globalSettingsMailboxInfo: MailboxInfo,
        onDialogResponse: (response: boolean) => void,
        projectionTabId: string | undefined
    ): void => {
        const store = getStore();
        store.isShown = isOpen;
        store.title = title;
        store.message = message;
        store.isCrossAccountNotAllowed = isCrossAccountNotAllowed;
        store.type = type;
        store.sourceMailboxInfo = sourceMailboxInfo;
        store.destinationMailboxInfo = destinationMailboxInfo;
        store.globalSettingsMailboxInfo = globalSettingsMailboxInfo;
        store.onDialogResponse = onDialogResponse;
        store.projectionTabId = projectionTabId;
    }
);

export const closeMoveCopyAttachCrossAccountDialogMutator: () => void = mutatorAction(
    'closeMoveCopyAttachCrossAccountDialogMutator',
    (): void => {
        const store = getStore();
        store.isShown = false;
        store.title = undefined;
        store.message = undefined;
        store.isCrossAccountNotAllowed = false;
        store.sourceMailboxInfo = undefined;
        store.destinationMailboxInfo = undefined;
        store.globalSettingsMailboxInfo = undefined;
        store.onDialogResponse = undefined;
        store.type = undefined;
        store.projectionTabId = undefined;
    }
);
